import { Product } from '../../types';

export const brassLugsProducts: Product[] = [
  {
    id: "bt-lugs-sbl011101",
    name: "Brass Lug - Maruti Lugs Economy (SBL011101)",
    slug: "brass-lug-maruti-lugs-economy-sbl011101",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Closed-barrel ring terminal for Maruti vehicles. Economy variant with standard specifications.",
    partNumber: "SBL011101",
    specifications: {
      "Description": "Maruti Lugs Economy",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "8.50 mm",
      "Ring Outer Diameter": "18.40 mm",
      "Crimp Barrel Width": "3.20 mm",
      "Type": "Closed-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011101.jpg"],
    tags: ["lug", "brass", "maruti", "ring terminal", "closed barrel"],
    applications: ["Automotive", "Battery Connections", "Maruti Vehicles"],
  },
  {
    id: "bt-lugs-sbl011102",
    name: "Brass Lug - Maruti Lugs (SBL011102)",
    slug: "brass-lug-maruti-lugs-sbl011102",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Closed-barrel ring terminal for Maruti vehicles. Standard variant with enhanced specifications.",
    partNumber: "SBL011102",
    specifications: {
      "Description": "Maruti Lugs",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "8.50 mm",
      "Ring Outer Diameter": "18.40 mm",
      "Crimp Barrel Width": "3.20 mm",
      "Type": "Closed-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011102.jpg"],
    tags: ["lug", "brass", "maruti", "ring terminal", "closed barrel"],
    applications: ["Automotive", "Battery Connections", "Maruti Vehicles"],
  },
  {
    id: "bt-lugs-sbl011111",
    name: "Brass Lug - Maruti Van Type (SBL011111)",
    slug: "brass-lug-maruti-van-type-sbl011111",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Flat spade-like terminal with circular hole for Maruti van applications. Closed crimp barrel design.",
    partNumber: "SBL011111",
    specifications: {
      "Description": "Maruti Van Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Overall Length": "30.00 mm",
      "Crimp End Width": "9.40 mm",
      "Total Height": "34.35 mm",
      "Type": "Spade Terminal with Closed Barrel",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011111.jpg"],
    tags: ["lug", "brass", "maruti", "van", "spade terminal"],
    applications: ["Automotive", "Battery Connections", "Maruti Van"],
  },
  {
    id: "bt-lugs-sbl011112",
    name: "Brass Lug - Maruti Car Type (SBL011112)",
    slug: "brass-lug-maruti-car-type-sbl011112",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Open-barrel spade terminal with circular hole for Maruti car applications.",
    partNumber: "SBL011112",
    specifications: {
      "Description": "Maruti Car Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Overall Length": "56.00 mm",
      "Spade End Width": "19.60 mm",
      "Type": "Open-Barrel Spade Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011112.jpg"],
    tags: ["lug", "brass", "maruti", "car", "spade terminal", "open barrel"],
    applications: ["Automotive", "Battery Connections", "Maruti Car"],
  },
  {
    id: "bt-lugs-sbl011116",
    name: "Brass Lug - Small Open (SBL011116)",
    slug: "brass-lug-small-open-sbl011116",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Small open-barrel ring terminal for compact applications. High conductivity brass construction.",
    partNumber: "SBL011116",
    specifications: {
      "Description": "Small Open",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "10.00 mm",
      "Ring Outer Diameter": "19.20 mm",
      "Overall Length": "40.20 mm",
      "Type": "Open-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011116.jpg"],
    tags: ["lug", "brass", "ring terminal", "open barrel", "small"],
    applications: ["Automotive", "Battery Connections", "Compact Applications"],
  },
  {
    id: "bt-lugs-sbl011118",
    name: "Brass Lug - Small Open Inter DI Hole (SBL011118)",
    slug: "brass-lug-small-open-inter-di-hole-sbl011118",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Small open-barrel ring terminal with intermediate diameter hole. Enhanced design for specific applications.",
    partNumber: "SBL011118",
    specifications: {
      "Description": "Small Open Inter DI Hole",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Outer Diameter": "22.20 mm",
      "Overall Length": "41.60 mm",
      "Type": "Open-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011118.jpg"],
    tags: ["lug", "brass", "ring terminal", "open barrel", "intermediate diameter"],
    applications: ["Automotive", "Battery Connections"],
  },
  {
    id: "bt-lugs-sbl011121",
    name: "Brass Lug - Small U Type (SBL011121)",
    slug: "brass-lug-small-u-type-sbl011121",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Small open-barrel U-type (spade) terminal for compact applications.",
    partNumber: "SBL011121",
    specifications: {
      "Description": "Small U Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Spade Opening": "9.95 mm",
      "Outer Width": "18.35 mm",
      "Overall Length": "41.00 mm",
      "Type": "Open-Barrel U-Type Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011121.jpg"],
    tags: ["lug", "brass", "u type", "spade", "open barrel", "small"],
    applications: ["Automotive", "Battery Connections", "Compact Applications"],
  },
  {
    id: "bt-lugs-sbl011122",
    name: "Brass Lug - Big Hole Open U Type OEM (SBL011122)",
    slug: "brass-lug-big-hole-open-u-type-oem-sbl011122",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Large hole open U-type terminal for OEM applications. High-quality brass construction.",
    partNumber: "SBL011122",
    specifications: {
      "Description": "Big Hole Open U Type OEM",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "11.00±0.10 mm",
      "Ring Outer Diameter": "19.00±0.05 mm",
      "Total Height": "42.80±0.30 mm",
      "Barrel Length": "16.00±0.10 mm",
      "Barrel Width": "41.50±0.20 mm",
      "Type": "Open-Barrel U-Type Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011122.jpg"],
    tags: ["lug", "brass", "u type", "oem", "open barrel", "big hole"],
    applications: ["Automotive", "Battery Connections", "OEM Applications"],
  },
  {
    id: "bt-lugs-sbl011123",
    name: "Brass Lug - Small Hole Open U Type OEM (SBL011123)",
    slug: "brass-lug-small-hole-open-u-type-oem-sbl011123",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Small hole open U-type terminal for OEM applications. Compact design with high conductivity.",
    partNumber: "SBL011123",
    specifications: {
      "Description": "Small Hole Open U Type OEM",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "9.00±0.10 mm",
      "Ring Outer Diameter": "19.00±0.05 mm",
      "Total Height": "42.80±0.30 mm",
      "Barrel Length": "16.00±0.10 mm",
      "Barrel Width": "41.50±0.20 mm",
      "Type": "Open-Barrel U-Type Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011123.jpg"],
    tags: ["lug", "brass", "u type", "oem", "open barrel", "small hole"],
    applications: ["Automotive", "Battery Connections", "OEM Applications"],
  },
  {
    id: "bt-lugs-sbl011125",
    name: "Brass Lug - Small Close (SBL011125)",
    slug: "brass-lug-small-close-sbl011125",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Small closed-barrel ring terminal. Compact design for space-constrained applications.",
    partNumber: "SBL011125",
    specifications: {
      "Description": "Small Close",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "10.00 mm",
      "Total Height": "40.00 mm",
      "Barrel Length": "14.80 mm",
      "Type": "Closed-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011125.jpg"],
    tags: ["lug", "brass", "ring terminal", "closed barrel", "small"],
    applications: ["Automotive", "Battery Connections", "Compact Applications"],
  },
  {
    id: "bt-lugs-sbl011129",
    name: "Brass Lug - Sleek White (SBL011129)",
    slug: "brass-lug-sleek-white-sbl011129",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Sleek white finish closed-barrel ring terminal. Premium appearance with high conductivity.",
    partNumber: "SBL011129",
    specifications: {
      "Description": "Sleek White",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "10.05±0.10 mm",
      "Total Height": "39.60 mm",
      "Barrel Length": "13.50 mm",
      "Type": "Closed-Barrel Ring Terminal",
      "Finish": "White",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011129.jpg"],
    tags: ["lug", "brass", "ring terminal", "closed barrel", "white", "sleek"],
    applications: ["Automotive", "Battery Connections", "Premium Applications"],
  },
  {
    id: "bt-lugs-sbl011132",
    name: "Brass Lug - OEM Type (SBL011132)",
    slug: "brass-lug-oem-type-sbl011132",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "OEM type closed-barrel ring terminal. Standard thickness variant for original equipment applications.",
    partNumber: "SBL011132",
    specifications: {
      "Description": "OEM Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "10.05±0.10 mm",
      "Ring Outer Diameter": "23.50±0.10 mm",
      "Thickness": "0.90±0.05 mm",
      "Total Height": "48.60±0.20 mm",
      "Barrel Length": "22.30±0.20 mm",
      "Type": "Closed-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011132.jpg"],
    tags: ["lug", "brass", "ring terminal", "closed barrel", "oem"],
    applications: ["Automotive", "Battery Connections", "OEM Applications"],
  },
  {
    id: "bt-lugs-sbl011133",
    name: "Brass Lug - OEM Type (SBL011133)",
    slug: "brass-lug-oem-type-sbl011133",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "OEM type closed-barrel ring terminal. Medium thickness variant for original equipment applications.",
    partNumber: "SBL011133",
    specifications: {
      "Description": "OEM Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "10.05±0.10 mm",
      "Ring Outer Diameter": "23.50±0.10 mm",
      "Thickness": "1.00±0.05 mm",
      "Total Height": "48.60±0.20 mm",
      "Barrel Length": "22.30±0.20 mm",
      "Type": "Closed-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011133.jpg"],
    tags: ["lug", "brass", "ring terminal", "closed barrel", "oem"],
    applications: ["Automotive", "Battery Connections", "OEM Applications"],
  },
  {
    id: "bt-lugs-sbl011134",
    name: "Brass Lug - OEM Type (SBL011134)",
    slug: "brass-lug-oem-type-sbl011134",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "OEM type closed-barrel ring terminal. Thicker variant for heavy-duty original equipment applications.",
    partNumber: "SBL011134",
    specifications: {
      "Description": "OEM Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "10.05±0.10 mm",
      "Ring Outer Diameter": "23.50±0.10 mm",
      "Thickness": "1.10±0.05 mm",
      "Total Height": "48.60±0.20 mm",
      "Barrel Length": "22.30±0.20 mm",
      "Type": "Closed-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011134.jpg"],
    tags: ["lug", "brass", "ring terminal", "closed barrel", "oem"],
    applications: ["Automotive", "Battery Connections", "OEM Applications"],
  },
  {
    id: "bt-lugs-sbl011135",
    name: "Brass Lug - OEM Type (SBL011135)",
    slug: "brass-lug-oem-type-sbl011135",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "OEM type closed-barrel ring terminal. Standard thickness variant for original equipment applications.",
    partNumber: "SBL011135",
    specifications: {
      "Description": "OEM Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "10.05±0.10 mm",
      "Ring Outer Diameter": "23.50±0.10 mm",
      "Thickness": "1.20±0.05 mm",
      "Total Height": "48.60±0.20 mm",
      "Barrel Length": "22.30±0.20 mm",
      "Barrel Width": "1.80±0.20 mm",
      "Type": "Closed-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011135.jpg"],
    tags: ["lug", "brass", "ring terminal", "closed barrel", "oem"],
    applications: ["Automotive", "Battery Connections", "OEM Applications"],
  },
  {
    id: "bt-lugs-sbl011136",
    name: "Brass Lug - OEM Type (SBL011136)",
    slug: "brass-lug-oem-type-sbl011136",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "OEM type closed-barrel ring terminal. Medium thickness variant for original equipment applications.",
    partNumber: "SBL011136",
    specifications: {
      "Description": "OEM Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "10.05±0.10 mm",
      "Ring Outer Diameter": "23.50±0.10 mm",
      "Thickness": "1.30±0.05 mm",
      "Total Height": "48.60±0.20 mm",
      "Barrel Length": "22.30±0.20 mm",
      "Barrel Width": "1.80±0.20 mm",
      "Type": "Closed-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011136.jpg"],
    tags: ["lug", "brass", "ring terminal", "closed barrel", "oem"],
    applications: ["Automotive", "Battery Connections", "OEM Applications"],
  },
  {
    id: "bt-lugs-sbl011137",
    name: "Brass Lug - OEM Type (SBL011137)",
    slug: "brass-lug-oem-type-sbl011137",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "OEM type closed-barrel ring terminal. Thicker variant for heavy-duty original equipment applications.",
    partNumber: "SBL011137",
    specifications: {
      "Description": "OEM Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "10.05±0.10 mm",
      "Ring Outer Diameter": "23.50±0.10 mm",
      "Thickness": "1.50±0.05 mm",
      "Total Height": "48.60±0.20 mm",
      "Barrel Length": "22.30±0.20 mm",
      "Barrel Width": "1.80±0.20 mm",
      "Type": "Closed-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011137.jpg"],
    tags: ["lug", "brass", "ring terminal", "closed barrel", "oem"],
    applications: ["Automotive", "Battery Connections", "OEM Applications"],
  },
  {
    id: "bt-lugs-sbl011138",
    name: "Brass Lug - OEM Type (SBL011138)",
    slug: "brass-lug-oem-type-sbl011138",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "OEM type closed-barrel ring terminal. Extra thick variant for heavy-duty original equipment applications.",
    partNumber: "SBL011138",
    specifications: {
      "Description": "OEM Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "10.05±0.10 mm",
      "Ring Outer Diameter": "23.50±0.10 mm",
      "Thickness": "1.70±0.05 mm",
      "Total Height": "48.60±0.20 mm",
      "Barrel Length": "22.30±0.20 mm",
      "Barrel Width": "1.80±0.20 mm",
      "Type": "Closed-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011138.jpg"],
    tags: ["lug", "brass", "ring terminal", "closed barrel", "oem"],
    applications: ["Automotive", "Battery Connections", "OEM Applications"],
  },
  {
    id: "bt-lugs-sbl011139",
    name: "Brass Lug - OEM Type (SBL011139)",
    slug: "brass-lug-oem-type-sbl011139",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "OEM type closed-barrel ring terminal. Maximum thickness variant for extra heavy-duty original equipment applications.",
    partNumber: "SBL011139",
    specifications: {
      "Description": "OEM Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Inner Diameter": "10.05±0.10 mm",
      "Ring Outer Diameter": "23.50±0.10 mm",
      "Thickness": "1.80±0.05 mm",
      "Total Height": "48.60±0.20 mm",
      "Barrel Length": "22.30±0.20 mm",
      "Barrel Width": "1.80±0.20 mm",
      "Type": "Closed-Barrel Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011139.jpg"],
    tags: ["lug", "brass", "ring terminal", "closed barrel", "oem"],
    applications: ["Automotive", "Battery Connections", "OEM Applications"],
  },
  {
    id: "bt-lugs-sbl011144",
    name: "Brass Lug - No 16 Light Duty (SBL011144)",
    slug: "brass-lug-no-16-light-duty-sbl011144",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "No 16 light duty spade terminal. Open U-type design for standard applications.",
    partNumber: "SBL011144",
    specifications: {
      "Description": "No 16 Light Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Total Length": "25.00±0.2 mm",
      "Fork Opening": "11.50±0.2 mm",
      "Inner Fork Width": "15.00±0.24 mm",
      "Total Width": "21.00±0.20 mm",
      "Barrel Width": "22.70±0.24 mm",
      "Total Height": "50.40±0.5 mm",
      "Thickness": "1.10±0.05 mm",
      "Type": "Open-Barrel Spade Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011144.jpg"],
    tags: ["lug", "brass", "spade", "u type", "open barrel", "light duty", "no 16"],
    applications: ["Automotive", "Battery Connections", "Light Duty Applications"],
  },
  {
    id: "bt-lugs-sbl011146",
    name: "Brass Lug - No 14 Medium Duty (SBL011146)",
    slug: "brass-lug-no-14-medium-duty-sbl011146",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "No 14 medium duty spade terminal. Open U-type design for medium-duty applications.",
    partNumber: "SBL011146",
    specifications: {
      "Description": "No 14 Medium Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Total Length": "25.00±0.2 mm",
      "Fork Opening": "11.50±0.2 mm",
      "Inner Fork Width": "15.00±0.24 mm",
      "Total Width": "21.00±0.20 mm",
      "Barrel Width": "22.70±0.24 mm",
      "Total Height": "50.40±0.5 mm",
      "Thickness": "1.30±0.05 mm",
      "Type": "Open-Barrel Spade Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011146.jpg"],
    tags: ["lug", "brass", "spade", "u type", "open barrel", "medium duty", "no 14"],
    applications: ["Automotive", "Battery Connections", "Medium Duty Applications"],
  },
  {
    id: "bt-lugs-sbl011148",
    name: "Brass Lug - No 12 Heavy Duty (SBL011148)",
    slug: "brass-lug-no-12-heavy-duty-sbl011148",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "No 12 heavy duty spade terminal. Open U-type design for heavy-duty applications.",
    partNumber: "SBL011148",
    specifications: {
      "Description": "No 12 Heavy Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Outer Diameter": "11.50±0.2 mm",
      "Total Height": "50.40+0.3 mm",
      "Thickness": "1.50±0.05 mm",
      "Bottom Thickness": "1.80 mm",
      "Type": "Open-Barrel Spade Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011148.jpg"],
    tags: ["lug", "brass", "spade", "u type", "open barrel", "heavy duty", "no 12"],
    applications: ["Automotive", "Battery Connections", "Heavy Duty Applications"],
  },
  {
    id: "bt-lugs-sbl011150",
    name: "Brass Lug - No 10 Extra Heavy Duty (SBL011150)",
    slug: "brass-lug-no-10-extra-heavy-duty-sbl011150",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "No 10 extra heavy duty spade terminal. Open U-type design for extra heavy-duty applications.",
    partNumber: "SBL011150",
    specifications: {
      "Description": "No 10 Extra Heavy Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Outer Diameter": "11.50±0.2 mm",
      "Total Height": "50.50+0.3 mm",
      "Thickness": "1.95±0.05 mm",
      "Bottom Thickness": "1.80 mm",
      "Type": "Open-Barrel Spade Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011150.jpg"],
    tags: ["lug", "brass", "spade", "u type", "open barrel", "extra heavy duty", "no 10"],
    applications: ["Automotive", "Battery Connections", "Extra Heavy Duty Applications"],
  },
  {
    id: "bt-lugs-sbl011152",
    name: "Brass Lug - No 8 Extra Ordinary Heavy Duty (SBL011152)",
    slug: "brass-lug-no-8-extra-ordinary-heavy-duty-sbl011152",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "No 8 extra ordinary heavy duty spade terminal. Open U-type design for maximum heavy-duty applications.",
    partNumber: "SBL011152",
    specifications: {
      "Description": "No 8 Extra Ordinary Heavy Duty",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Outer Diameter": "11.50±0.2 mm",
      "Total Height": "50.50+0.3 mm",
      "Thickness": "2.10±0.05 mm",
      "Bottom Thickness": "1.80 mm",
      "Type": "Open-Barrel Spade Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011152.jpg"],
    tags: ["lug", "brass", "spade", "u type", "open barrel", "extra ordinary heavy duty", "no 8"],
    applications: ["Automotive", "Battery Connections", "Extra Ordinary Heavy Duty Applications"],
  },
  {
    id: "bt-lugs-sbl011158",
    name: "Brass Lug - Big Open U Type (SBL011158)",
    slug: "brass-lug-big-open-u-type-sbl011158",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Large open U-type spade terminal for heavy-duty applications. Enhanced design for high-current applications.",
    partNumber: "SBL011158",
    specifications: {
      "Description": "Big Open U Type",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Outer Diameter": "25.10 mm",
      "Ring Inner Diameter": "12.70 mm",
      "Overall Length": "42.70 mm",
      "Total Height": "55.00 mm",
      "Thickness": "1.10 mm",
      "Type": "Open-Barrel U-Type Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011158.jpg"],
    tags: ["lug", "brass", "u type", "spade", "open barrel", "big"],
    applications: ["Automotive", "Battery Connections", "Heavy Duty Applications"],
  },
  {
    id: "bt-lugs-sbl011160",
    name: "Brass Lug - Big Close Round (SBL011160)",
    slug: "brass-lug-big-close-round-sbl011160",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Large closed round terminal for heavy-duty applications. Closed-barrel design for enhanced reliability.",
    partNumber: "SBL011160",
    specifications: {
      "Description": "Big Close Round",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Outer Diameter": "23.60 mm",
      "Ring Inner Diameter": "11.60 mm",
      "Overall Length": "35.00 mm",
      "Total Height": "55.00 mm",
      "Bottom Height": "22.00 mm",
      "Thickness": "1.10 mm",
      "Type": "Closed-Barrel Round Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011160.jpg"],
    tags: ["lug", "brass", "round", "closed barrel", "big"],
    applications: ["Automotive", "Battery Connections", "Heavy Duty Applications"],
  },
  {
    id: "bt-lugs-sbl011164",
    name: "Brass Lug - Big Open U Type White (SBL011164)",
    slug: "brass-lug-big-open-u-type-white-sbl011164",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Large open U-type spade terminal with white finish. Premium appearance for heavy-duty applications.",
    partNumber: "SBL011164",
    specifications: {
      "Description": "Big Open U Type White",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Outer Diameter": "12.50 mm",
      "Overall Length": "27.90 mm",
      "Total Height": "53.50+0.3 mm",
      "Thickness": "1.50±0.05 mm",
      "Bottom Thickness": "1.80 mm",
      "Type": "Open-Barrel U-Type Terminal",
      "Finish": "White",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011164.jpg"],
    tags: ["lug", "brass", "u type", "spade", "open barrel", "big", "white"],
    applications: ["Automotive", "Battery Connections", "Heavy Duty Applications", "Premium Applications"],
  },
  {
    id: "bt-lugs-sbl011168",
    name: "Brass Lug - Special White (SBL011168)",
    slug: "brass-lug-special-white-sbl011168",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Special white finish ring terminal. Premium design with enhanced aesthetics.",
    partNumber: "SBL011168",
    specifications: {
      "Description": "Special White",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Ring Outer Diameter": "24.50 mm",
      "Ring Inner Diameter": "15.40 mm",
      "Total Height": "50.00 mm",
      "Bottom Height": "18.60 mm",
      "Thickness": "1.50 mm",
      "Type": "Ring Terminal",
      "Finish": "White",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011168.jpg"],
    tags: ["lug", "brass", "ring terminal", "white", "special"],
    applications: ["Automotive", "Battery Connections", "Premium Applications"],
  },
  {
    id: "bt-lugs-sbl011171",
    name: "Brass Lug - Inter DI Big Hole (SBL011171)",
    slug: "brass-lug-inter-di-big-hole-sbl011171",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Intermediate diameter big hole ring terminal. Large opening for heavy-duty battery connections.",
    partNumber: "SBL011171",
    specifications: {
      "Description": "Inter DI Big Hole",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Overall Length": "50.00 mm",
      "Ring Outer Diameter": "24.50 mm",
      "Ring Inner Diameter": "15.40 mm",
      "Crimp Barrel Width": "16.80 mm",
      "Ring Thickness": "1.50 mm",
      "Crimp Barrel Height": "18.60 mm",
      "Type": "Ring Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011171.jpg"],
    tags: ["lug", "brass", "ring terminal", "big hole", "intermediate diameter"],
    applications: ["Automotive", "Battery Connections", "Heavy Duty Applications"],
  },
  {
    id: "bt-lugs-sbl011175",
    name: "Brass Lug - OE Type (Negative & Positive) (SBL011175)",
    slug: "brass-lug-oe-type-negative-positive-sbl011175",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Original equipment type ring terminal set, includes both negative and positive terminals. High-quality brass construction.",
    partNumber: "SBL011175",
    specifications: {
      "Description": "OE Type (Negative & Positive)",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Overall Length": "57.30 mm",
      "Ring Outer Diameter": "20.90 mm",
      "Ring Thickness": "3.00 mm",
      "Crimp Barrel Height": "25.50 mm",
      "Crimp Barrel Width": "16.80 mm",
      "Negative Ring Inner Diameter": "10.40 mm",
      "Positive Ring Inner Diameter": "12.00 mm",
      "Type": "Ring Terminal Set",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011175.jpg"],
    tags: ["lug", "brass", "ring terminal", "oe type", "negative", "positive"],
    applications: ["Automotive", "Battery Connections", "OE Applications"],
  },
  {
    id: "bt-lugs-sbl011176",
    name: "Brass Lug - OE Type (Negative & Positive) (SBL011176)",
    slug: "brass-lug-oe-type-negative-positive-sbl011176",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "Original equipment type sheet terminal set, includes both negative and positive terminals with polarity markings.",
    partNumber: "SBL011176",
    specifications: {
      "Description": "OE Type (Negative & Positive)",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Overall Height": "46.50±0.20 mm",
      "Thickness": "3.00 mm",
      "Crimp Section Height": "25.50±0.20 mm",
      "Crimp Section Width": "18.00+0.20 mm",
      "Negative Hole Diameter": "12.00±0.20 mm",
      "Positive Hole Diameter": "21.00±0.20 mm",
      "Type": "Sheet Terminal Set",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011176.jpg"],
    tags: ["lug", "brass", "sheet terminal", "oe type", "negative", "positive", "polarity marked"],
    applications: ["Automotive", "Battery Connections", "OE Applications"],
  },
  {
    id: "bt-lugs-sbl011178",
    name: "Brass Lug - L Type OEM (SBL011178)",
    slug: "brass-lug-l-type-oem-sbl011178",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "L-shaped OEM terminal with circular hole. Compact design for space-constrained applications.",
    partNumber: "SBL011178",
    specifications: {
      "Description": "L Type OEM",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Hole Diameter": "9.00+0.10 mm",
      "Top Section Width": "30.00+0.10 mm",
      "Top Section Thickness": "8.00±0.05 mm",
      "Crimp Section Width": "6.00±0.10 mm",
      "Overall Height": "43.00±0.10 mm",
      "Thickness": "2.00 mm",
      "Type": "L-Shaped Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011178.jpg"],
    tags: ["lug", "brass", "l type", "oem", "compact"],
    applications: ["Automotive", "Battery Connections", "OEM Applications", "Space Constrained"],
  },
  {
    id: "bt-lugs-sbl011179",
    name: "Brass Lug - L Type OEM (SBL011179)",
    slug: "brass-lug-l-type-oem-sbl011179",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "L-shaped OEM terminal with larger circular hole. Enhanced design for heavy-duty applications.",
    partNumber: "SBL011179",
    specifications: {
      "Description": "L Type OEM",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Hole Diameter": "19.00+0.10 mm",
      "Top Section Width": "39.00±0.20 mm",
      "Top Section Thickness": "9.00+0.10 mm",
      "Crimp Section Width": "6.00±0.10 mm",
      "Overall Height": "47.00±0.10 mm",
      "Thickness": "2.00 mm",
      "Type": "L-Shaped Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011179.jpg"],
    tags: ["lug", "brass", "l type", "oem", "heavy duty"],
    applications: ["Automotive", "Battery Connections", "OEM Applications", "Heavy Duty Applications"],
  },
  {
    id: "bt-lugs-sbl011180",
    name: "Brass Lug - L Type OEM (SBL011180)",
    slug: "brass-lug-l-type-oem-sbl011180",
    category: "Brass Terminal",
    subcategory: "Brass Lugs",
    description: "L-shaped OEM fork terminal with circular hole. Premium design for OEM applications.",
    partNumber: "SBL011180",
    specifications: {
      "Description": "L Type OEM",
      "Material": "CuZn-63/37",
      "Standard Packing": "Cut-12 Pcs.",
      "Hole Diameter": "19.00+0.10 mm",
      "Overall Height": "50.00±0.20 mm",
      "Height from Hole to Bottom": "38.00±0.20 mm",
      "Thickness": "2.00±0.02 mm",
      "Type": "L-Shaped Fork Terminal",
    },
    images: ["/products/brass-terminals/brass-lugs/SBL011180.jpg"],
    tags: ["lug", "brass", "l type", "oem", "fork terminal"],
    applications: ["Automotive", "Battery Connections", "OEM Applications"],
  },
];
